import { render, staticRenderFns } from "./inspectionPlanIndex.vue?vue&type=template&id=0c4c0588&scoped=true"
import script from "./inspectionPlanIndex.vue?vue&type=script&lang=js"
export * from "./inspectionPlanIndex.vue?vue&type=script&lang=js"
import style0 from "./inspectionPlanIndex.vue?vue&type=style&index=0&id=0c4c0588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c0588",
  null
  
)

export default component.exports